import {ref} from "vue";
import {TreeProps} from "ant-design-vue";
import {QueryAllAccountList} from "../servers/userSelServer";
import GoingUtils from "@/utils/goingUtils";
import {initTreeData} from "xmgoing-utils";
import {deepClone} from 'xmgoing-utils';

export function useAccountShowTree(emits) {
    //展开keys
    const expandedKeys = ref<string[]>([]);
    //机构树
    const orgTreeList: any = ref<TreeProps['treeData']>([]);
    //选择记录集合
    const selectedKeys = ref<string[]>([]);
    /**
     * 刷新组织机构列表
     */
    const flusAccountList = () => {
      QueryAllAccountList('', (res) => {
            GoingUtils.closeLoading();
            if (res) {
                orgTreeList.value = initTreeData(deepClone(res), unref(expandedKeys));
            }
        })
    }

    /**
     * 选择组织架构查询用户
     * @param selectedKeys
     */
    const selectAccount = (keys) => {
        emits('selItemRecord', {key: keys[0]});
    }

    //查询部门信息
    flusAccountList();

    return {
        selectedKeys,
        selectAccount,
        expandedKeys,
        orgTreeList,
    }
}
